export default __webpack_public_path__ + "57c077ec72a8b82910180336565fc97e.png";